import { Link } from "react-router-dom";
import { Facebook, Twitter, Youtube, Instagram, Mail } from "lucide-react";
import { TID } from "@/constants/testIds";
import { NEMA_LOGO } from "@/assets/logo";

const QRPlaceholder = ({ label }) => (
  <div className="flex flex-col items-center gap-2">
    <div
      className="w-20 h-20 rounded-lg bg-white p-1.5"
      aria-hidden="true"
      style={{
        backgroundImage:
          "repeating-conic-gradient(#05030A 0% 25%, #ffffff 0% 50%)",
        backgroundSize: "8px 8px",
      }}
    />
    <div className="text-[10px] uppercase tracking-[0.2em] text-white/60">{label}</div>
  </div>
);

const Footer = () => (
  <footer data-testid={TID.footer.root} className="relative border-t border-white/10 pt-16 pb-10">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Link to="/">
            <img src={NEMA_LOGO} alt="Nema TV" className="h-10 w-auto" />
          </Link>
          <p className="mt-5 text-white/60 max-w-sm">
            The ultimate streaming destination for the diaspora. Watch live TV,
            news and culture from around the world — anywhere in the world.
          </p>

          <ul className="mt-6 space-y-2 text-sm text-white/75">
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#22D3EE]" /> <a className="hover:text-white" href="mailto:contact@nematv.com">contact@nematv.com</a></li>
          </ul>

          <div className="mt-6 flex items-center gap-3">
            <div className="text-xs uppercase tracking-[0.2em] text-white/50">Follow us</div>
            <div className="flex items-center gap-2 text-white/70">
              <a href="#" aria-label="Facebook"  className="w-8 h-8 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 grid place-items-center"><Facebook className="w-4 h-4" /></a>
              <a href="#" aria-label="Twitter"   className="w-8 h-8 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 grid place-items-center"><Twitter className="w-4 h-4" /></a>
              <a href="#" aria-label="YouTube"   className="w-8 h-8 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 grid place-items-center"><Youtube className="w-4 h-4" /></a>
              <a href="#" aria-label="Instagram" className="w-8 h-8 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 grid place-items-center"><Instagram className="w-4 h-4" /></a>
            </div>
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Company</h4>
          <ul className="space-y-3 text-sm text-white/75">
            <li><Link to="/about"     className="hover:text-white transition-colors">About Us</Link></li>
            <li><Link to="/dmca"      className="hover:text-white transition-colors">DMCA</Link></li>
            <li><Link to="/advertise" className="hover:text-white transition-colors">Advertise</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Resources</h4>
          <ul className="space-y-3 text-sm text-white/75">
            <li><Link to="/faq"       className="hover:text-white transition-colors">FAQ</Link></li>
            <li><Link to="/help"      className="hover:text-white transition-colors">Help Center</Link></li>
            <li><Link to="/tutorials" className="hover:text-white transition-colors">Tutorials</Link></li>
            <li><a  href="/api/rss.xml" data-testid="footer-rss-link" className="hover:text-white transition-colors">RSS Feed</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Legal</h4>
          <ul className="space-y-3 text-sm text-white/75 mb-6">
            <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms"   className="hover:text-white transition-colors">Terms of Use</Link></li>
          </ul>

          <h4 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-3">Download the app</h4>
          <div className="flex items-center gap-4">
            <QRPlaceholder label="Google Play" />
            <QRPlaceholder label="App Store" />
          </div>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
        <div>© {new Date().getFullYear()} Nema TV. All rights reserved. Live South Asian TV for the diaspora.</div>
        <div className="flex gap-6">
          <Link to="/terms"   className="hover:text-white/70 transition-colors">Terms</Link>
          <Link to="/privacy" className="hover:text-white/70 transition-colors">Privacy</Link>
          <Link to="/help"    className="hover:text-white/70 transition-colors">Support</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
